import { Risk as RiskProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/risk';
import { Risk } from '../Risk';

export function mapToApiRequest(risk: Risk): RiskProtos {
  const childrens = risk.childrenList ?? [];

  return {
    persons: risk.adultsList?.concat(childrens) ?? [],
  };
}
